(function() {
  function fixMobileOp15Links(root) {
    return;
  }

  function applyImageFitMode(img) {
    if (!img) return;

    function updateFitMode() {
      if (!img.naturalWidth || !img.naturalHeight) return;
      var wrapper = img.closest('.product-card-wrapper');
      if (!wrapper || !wrapper.classList.contains('bgtcg-non-single-card')) return;

      var ratio = img.naturalWidth / img.naturalHeight;
      var isFourFive = Math.abs(ratio - 0.8) <= 0.035;
      img.classList.toggle('bgtcg-img-45-fit', isFourFive);
      img.style.setProperty('object-fit', isFourFive ? 'cover' : 'contain', 'important');
      img.style.setProperty('padding', isFourFive ? '0' : '10px', 'important');
    }

    if (img.complete) {
      updateFitMode();
    } else {
      img.addEventListener('load', updateFitMode, { once: true });
    }
  }

  function applyAll(root) {
    root = root || document;
    root.querySelectorAll('.product-card-wrapper.bgtcg-non-single-card .card__media .media img').forEach(applyImageFitMode);
  }

  applyAll();
  fixMobileOp15Links();

  document.addEventListener('click', function(event) {
    var isMobile = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    if (!isMobile) return;

    var link = event.target.closest && event.target.closest('a[href]');
    if (!link) return;

    try {
      var url = new URL(link.getAttribute('href'), window.location.origin);
      return;
    } catch (error) {}
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      applyAll();
      fixMobileOp15Links();
      setTimeout(applyAll, 300);
      setTimeout(applyAll, 1000);
      setTimeout(fixMobileOp15Links, 300);
      setTimeout(fixMobileOp15Links, 1000);
    });
  } else {
    setTimeout(applyAll, 300);
    setTimeout(applyAll, 1000);
    setTimeout(fixMobileOp15Links, 300);
    setTimeout(fixMobileOp15Links, 1000);
  }

  if ('MutationObserver' in window) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) {
            applyAll(node);
            fixMobileOp15Links(node);
          }
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
